import React from 'react';
import styled from 'styled-components/macro';


const Container = styled.div`
  border-bottom: 10px solid ${({ theme }) => theme.colors.colorBlue};
  color: ${({ theme }) => theme.colors.colorBlue};
  padding: 10px;
  font-weight: bold;
`;
const Circle = styled.span`
  font-size: 28px;
`;

const Space = styled.div`
  display: inline-block;
  background: ${({ theme }) => theme.colors.colorBlue};
  width: 2px;
  height: 28px;
  margin: 0 10px;
  position: relative;
  top: 4px;
`;

const Title = styled.span`
  font-size: 18px;
    position: relative;
    top: -3px;
`;

export default ({
  number,
  text,
}) => (
  <Container>
    <Circle>
      {number}
    </Circle>
    <Space />
    <Title>
      {text}
    </Title>
  </Container>
);
